import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'kendo-grid',
})
export class GridDragAndDropDirective implements OnChanges {
  @Input() private isDraggable: boolean;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isDraggable) {
      const gridRoot: HTMLElement = this.elementRef.nativeElement.querySelector('.k-grid-aria-root');
      if (gridRoot && this.isDraggable) {
        this.renderer.setAttribute(gridRoot, 'draggable', String(this.isDraggable));
      }
    }
  }
}
